{
  "home": {
    "title": "控制面板",
    "welcome": "欢迎回来，{{name}}",
    "guest": "访客",
    "subtitle": "这是您今天的知识产权动态。",
    "currentApplication": "当前申请",
    "applicationProgress": "申请进度",
    "noActiveApplications": "暂无活跃申请",
    "createFirst": "创建您的第一个商标申请以开始。",
    "quickActions": "快捷操作",
    "resumeFiling": "报价与支付",
    "resumeFilingDesc": "查看报价并付款",
    "paymentHistory": "支付记录",
    "paymentHistoryDesc": "查看收据和发票",
    "contactSupport": "联系客服",
    "contactSupportDesc": "获取我们团队的帮助",
    "lastUpdated": "最后更新：{{date}}",
    "newFiling": "新商标查询",
    "viewAll": "查看全部",
    "continueFiling": "查看报价与支付",
    "payAndFile": "付款并提交",
    "viewQuoteStatus": "查看状态",
    "viewFilingStatus": "查看提交状态",
    "activeFilings": "活跃申请",
    "actionRequired": "需要操作",
    "protectedAssets": "受保护资产",
    "startProtecting": "从我们网站上的免费商标查询开始。您将在24小时内收到详细报告和由律师确认的报价，无需预先付款。",
    "startNewApp": "开始免费查询",
    "fromYourAttorney": "来自您的商标律师",
    "unnamedTrademark": "未命名商标",
    "insights": {
      "appInProgress": "申请进行中",
      "appInProgressMsg": "查看您的报价和付款状态，以推进您的申请。",
      "reportPreparing": "报告即将送达",
      "reportPreparingMsg": "我们正在准备您的商标报告和报价。24小时内您将收到邮件。",
      "quoteReady": "您的报价已就绪",
      "quoteReadyMsg": "您的律师确认报价已就绪。请查看并付款以开始提交申请。",
      "filingInProgress": "提交进行中",
      "filingInProgressMsg": "您的付款已完成。您的商标申请正在准备提交。",
      "paymentPending": "待支付",
      "paymentPendingMsg": "您的申请已准备好提交。完成支付以继续。",
      "startJourney": "开始您的旅程",
      "startJourneyMsg": "在我们的网站上获取免费商标查询和报价，无需预先付款。",
      "analysisComplete": "分析完成",
      "analysisCompleteMsg": "Marko已分析您的商标。查看报告了解潜在冲突。",
      "systemOp": "系统正常",
      "systemOpMsg": "所有监控系统运行正常"
    }
  },
  "status": {
    "inProgress": "进行中",
    "quoteRequested": "报告准备中",
    "quoteSent": "报价已就绪",
    "paymentPending": "待支付",
    "paymentComplete": "支付完成",
    "pendingFiling": "待提交",
    "filingInProgress": "提交进行中",
    "filed": "已提交",
    "registered": "已注册",
    "completed": "已完成",
    "cancelled": "已取消",
    "refunded": "已退款",
    "partiallyRefunded": "部分退款"
  },
  "payments": {
    "sectionTitle": "报价与支付",
    "sectionSubtitle": "查看报价、签署声明并完成支付",
    "noApplicationTitle": "暂无申请",
    "noApplicationMsg": "从我们网站上的免费商标查询开始。我们将在24小时内通过邮件发送详细报告和报价。",
    "startFreeCheck": "开始免费查询",
    "reportPreparingTitle": "您的报告正在准备中",
    "reportPreparingMsg": "我们的团队正在审核您的商标，并准备详细报告和报价。我们将在24小时内通过邮件发送给您。",
    "reportForTrademark": "商标：{{name}}",
    "loadingQuote": "正在加载您的报价…",
    "noQuoteTitle": "您的报价尚未就绪",
    "noQuoteMsg": "我们仍在为该申请敲定报价。报价就绪后您将立即收到邮件。如果您认为这是一个错误，请回复我们的任意邮件，我们会尽快处理。",
    "quoteTitle": "您的报价",
    "quoteSubtitle": "查看申请费用并完成支付",
    "quoteSubtitleConfirmed": "已由我们的律师确认——这是您将被收取的确切金额。",
    "breakdown": "报价明细",
    "countries": "国家/地区",
    "classes": "类别",
    "serviceFee": "服务费",
    "governmentFees": "官方申请费",
    "filingFee": "商标申请",
    "discount": "多国折扣",
    "total": "总计",
    "chargedIn": "以{{currency}}结算",
    "pendingRetry": "上一次付款尝试仍在处理中。您可以继续重试。",
    "attorneyServiceFee": "商标律师服务费",
    "quoteDocTitle": "报价单",
    "dateOfIssue": "开具日期",
    "quoteValidity": "有效期30天",
    "trademarkDetails": "商标详情",
    "markName": "商标",
    "markType": "类型",
    "applicant": "申请人",
    "viewFullReport": "查看完整报告",
    "hideFullReport": "收起完整报告",
    "reportExpanderHint": "我们的团队为您准备的商标报告",
    "settingUpPayment": "正在准备安全支付…",
    "paymentRetry": "重试",
    "overlayUnlock": "勾选上方声明后即可付款",
    "overlayUnlockApplicant": "请先在上方填写申请人信息，然后付款",
    "overlayUnlockBoth": "请先在上方填写申请人信息并勾选声明，然后付款",
    "applicantTbc": "待确认",
    "applicantDetails": {
      "title": "申请人信息",
      "subtitle": "商标将以此名义注册。商标局要求提供申请人名称和邮政地址才能提交申请。",
      "nameLabel": "申请人名称",
      "namePlaceholder": "完整法定姓名或公司名称",
      "streetLabel": "街道地址",
      "streetPlaceholder": "示例街 123 号",
      "cityLabel": "城市 / 区",
      "stateLabel": "州 / 省",
      "optional": "（可选）",
      "zipLabel": "邮政编码",
      "countryLabel": "国家/地区",
      "saving": "保存中…",
      "saved": "已保存",
      "saveError": "无法保存您的信息。您继续输入时将再次尝试保存。"
    },
    "declaration": {
      "loading": "正在加载声明…",
      "title": "授权与声明",
      "subtitle": "在我们代您提交商标申请之前必须完成",
      "combined": "本人确认有权申请该商标，本申请中的信息真实准确，并指定MarkoTM作为本人的代理人代为提交和管理本申请。本人接受",
      "signedBy": "签署人",
      "signedOn": "于 {{date}}",
      "saveError": "无法保存您的声明。请重试。"
    },
    "report": {
      "title": "您的商标报告",
      "subtitle": "由我们的团队准备",
      "preparedOn": "由我们的团队于{{date}}准备",
      "sections": {
        "overview": "概述",
        "markAssessment": "商标评估",
        "registerFindings": "注册簿检索结果",
        "coverageRationale": "保护范围说明",
        "ourRecommendation": "我们的建议",
        "nextSteps": "后续步骤"
      },
      "matchesTitle": "澳大利亚知识产权局注册簿检索结果",
      "matchName": "商标",
      "matchNumber": "编号",
      "matchStatus": "状态",
      "matchClasses": "类别"
    }
  },
  "sidebar": {
    "dashboard": "控制面板",
    "overview": "概览",
    "quoteAndPayment": "报价与支付",
    "quoteAndPaymentDesc": "查看报价并付款",
    "myPortfolio": "我的作品集",
    "viewTrademarks": "查看您的商标",
    "renewals": "续展",
    "upcomingDeadlines": "即将到期",
    "currentApplication": "当前申请",
    "settings": "设置",
    "portfolio": "我的作品集",
    "newApplication": "新建申请",
    "filingProgress": "申请进度",
    "documents": "文档",
    "billing": "账单"
  },
  "header": {
    "notifications": "通知",
    "profile": "个人资料",
    "logout": "退出登录"
  },
  "attorney": {
    "name": "Ken McInnes",
    "title": "商标战略主管",
    "greeting": "欢迎来到您的安全知识产权仪表板。您可以在此查看商标申请的进展，并在每个环节轻松与您指定的商标律师保持联系。"
  },
  "marko": {
    "analysisComplete": "我已分析您的商标！点击查看我的建议。",
    "multiCountry": "在多个国家申请？我会帮您确定优先顺序。",
    "thinking": "Marko正在思考...",
    "askMe": "向我咨询商标相关问题",
    "clickToChat": "点击聊天 →"
  },
  "application": {
    "create": "创建申请",
    "createNew": "创建新申请",
    "name": "申请名称",
    "namePlaceholder": "为您的商标申请命名",
    "nameHelp": "这有助于整理您的知识产权组合并跟踪申请进度。",
    "delete": "删除申请",
    "deleteConfirm": "您确定要删除此申请吗？此操作无法撤销。",
    "status": "申请状态",
    "progress": "进度"
  }
}
